import { render, staticRenderFns } from "./PortionCard.vue?vue&type=template&id=267cd12c&"
import script from "./PortionCard.vue?vue&type=script&lang=js&"
export * from "./PortionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports